module.exports = __webpack_public_path__ + "img/1585135530.0eb60f94.jpg";